import { logout } from "../store/reducers/authSlice";
import {
    clearTenantUser
} from "../store/reducers/tenantUserSlice";

export const performLogout = (
    dispatch,
    navigate
) => {

    localStorage.removeItem("token");

    localStorage.removeItem("user");

    localStorage.removeItem("tenantCode");

    localStorage.removeItem("refreshToken");

    dispatch(logout());

    dispatch(clearTenantUser());

    sessionStorage.clear();

    navigate(
        "/",
        {
            replace: true
        }
    );
};